import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagProvider';
import type { FeatureFlagKey } from './schemas';

export const useFeatureFlag = (key: FeatureFlagKey): boolean => {
  const { flags, status } = useContext(FeatureFlagContext);
  return status === 'ready' && flags[key];
};

export const useFeatureFlagStatus = () => useContext(FeatureFlagContext).status;
